// ============================================================
// HABIT OS — Deutsche Übersetzungen
// ============================================================

export const de = {
  // ── APP ──────────────────────────────────
  app_name: "Habit OS",

  // ── NAVIGATION ───────────────────────────
  nav_today:    "Heute",
  nav_coach:    "Coach",
  nav_insights: "Insights",
  nav_discover: "Entdecken",

  // ── GREETING ─────────────────────────────
  greeting_morning:   "Guten Morgen",
  greeting_afternoon: "Guten Tag",
  greeting_evening:   "Guten Abend",
  greeting_subtitle:  "Setze den Anker für deinen Tag.",

  // ── TODAY TAB ────────────────────────────
  today_progress:        "Heute",
  today_streak:          "Tage",
  today_last7:           "Letzte 7 Tage",
  today_freeze_title:    "Streak Freezes",
  today_freeze_subtitle: "Verdient durch alle Morning-Habits",
  today_protocol:        "Protokoll",
  today_morning:         "Morgen",
  today_morning_routine: "Morning Routine",
  today_night:           "Abend",
  today_night_routine:   "Night Routine",
  today_add_habit:       "+ Habit hinzufügen",
  today_search_habit:    "Habit suchen oder eingeben…",
  today_add_btn:         "Hinzufügen",
  today_from_library:    "Aus der Bibliothek wählen",
  today_more_library:    "Mehr in der Bibliothek entdecken →",
  today_freeze_earned:   "Freeze verdient ❄️",
  today_hero_badge:      "HERO",
  today_pro_badge:       "PRO",
  today_calendar_legend_complete:   "Vollständig",
  today_calendar_legend_freeze:     "Freeze",
  today_calendar_legend_grace:      "Grace",
  today_calendar_legend_missed:     "Verpasst",

  // ── INSIGHTS TAB ─────────────────────────
  insights_title:         "Dein Fortschritt",
  insights_subtitle:      "Letzte 30 Tage",
  insights_active_days:   "aktive Tage",
  insights_completion:    "Completion",
  insights_best_streak:   "Beste Streak",
  insights_habits_done:   "Habits done",
  insights_this_week:     "Diese Woche",
  insights_strongest:     "Stärkster Habit",
  insights_best_day:      "Bester Tag",
  insights_most_completions: "Meiste Completions",
  insights_ranking:       "Habit-Rangliste · 30 Tage",
  insights_more_habits:   "weitere Habits",
  insights_improvement:   "Verbesserungspotenzial",
  insights_no_data_title: "Noch keine Daten",
  insights_no_data_text:  "Hake deine ersten Habits ab — nach ein paar Tagen erscheinen hier deine Statistiken.",
  insights_loading:       "Statistiken werden geladen…",
  insights_times_done:    "× erledigt",
  insights_improvement_text: "wird nur {rate}% der Zeit erledigt. Überlege ob der Zeitpunkt oder der Aufwand angepasst werden kann.",

  // ── DISCOVER TAB ─────────────────────────
  discover_title:    "Bibliothek",
  discover_subtitle: "Entdecke neue Habits",
  discover_add:      "Hinzufügen",
  discover_added:    "Hinzugefügt ✓",
  discover_why:      "Warum?",
  discover_dose:     "Dosierung",
  discover_source:   "Quellen",
  discover_morning:  "Morgens",
  discover_night:    "Abends",

  // ── AGENT / COACH ─────────────────────────
  agent_ready:          "ist bereit",
  agent_typing:         "Schreib etwas…",
  agent_send:           "Senden",
  agent_change:         "wechseln ›",
  agent_proactive:      "Proaktiv",
  agent_weekly_review:  "Wöchentliches Review",
  agent_suggestion:     "Empfehlung",
  agent_options_review: "Wöchentliches Review",
  agent_options_change: "Begleiter wechseln",
  agent_options_clear:  "Verlauf löschen",
  agent_choose:         "Wähle deinen Begleiter",
  agent_active:         "AKTIV",
  agent_loading:        "Dein Begleiter wird vorbereitet…",
  agent_error:          "Ich konnte dich gerade nicht erreichen. Versuche es nochmal.",

  // ── PROFIL SHEET ─────────────────────────
  profile_progress:       "Dein Fortschritt",
  profile_streak:         "Streak",
  profile_freezes:        "Freezes",
  profile_plan:           "Plan",
  profile_plan_free:      "Free",
  profile_plan_pro:       "Pro",
  profile_section_profil: "Profil",
  profile_change_name:    "Name ändern",
  profile_email:          "E-Mail",
  profile_section_notifications: "Benachrichtigungen",
  profile_push_active:    "Aktiv — Erinnerungen werden gesendet",
  profile_push_inactive:  "Inaktiv",
  profile_push_denied:    "In Browser-Einstellungen blockiert",
  profile_push_unsupported: "Nicht unterstützt in diesem Browser",
  profile_morning_reminder: "☀️ Morning Reminder",
  profile_night_reminder:   "🌙 Night Reminder",
  profile_push_info:      "Benachrichtigungen werden in deiner lokalen Zeitzone gesendet. Änderungen werden automatisch gespeichert.",
  profile_section_settings: "Einstellungen",
  profile_dark_mode:      "Dark Mode",
  profile_dark_active:    "Dunkles Design aktiv",
  profile_light_active:   "Helles Design aktiv",
  profile_language:       "Sprache",
  profile_section_account: "Account",
  profile_upgrade:        "Auf Pro upgraden",
  profile_change_password: "Passwort ändern",
  profile_sign_out:       "Abmelden",
  profile_delete_account: "Konto löschen",
  profile_save:           "Speichern",
  profile_saving:         "Speichern…",
  profile_password_min:   "Mindestens 8 Zeichen.",
  profile_password_mismatch: "Passwörter stimmen nicht überein.",
  profile_password_changed: "Passwort geändert.",
  profile_name_saved:     "Name gespeichert.",
  profile_delete_warning: "Diese Aktion ist unwiderruflich. Alle deine Daten werden dauerhaft gelöscht.",
  profile_delete_confirm: "Tippe LÖSCHEN um zu bestätigen:",
  profile_delete_input:   "LÖSCHEN",
  profile_delete_btn:     "Konto endgültig löschen",
  profile_deleting:       "Wird gelöscht…",
  profile_push_enabled:   "Push-Benachrichtigungen aktiviert! ✓",
  profile_push_disabled:  "Push-Benachrichtigungen deaktiviert.",
  profile_push_denied_msg: "Berechtigung verweigert. Bitte in den Browser-Einstellungen aktivieren.",

  // ── ONBOARDING ───────────────────────────
  onboarding_goal_title:    "Was ist dein\nwichtigstes Ziel?",
  onboarding_goal_subtitle: "Wähle einen Fokus — du kannst ihn später jederzeit ändern.",
  onboarding_protocol_title: "Wähle dein Vorbild",
  onboarding_recommended:   "Empfohlen",
  onboarding_more:          "Weitere Vorbilder",
  onboarding_no_rolemodel:  "Lieber ohne Vorbild starten → Neuro-Optimizer",
  onboarding_ready_title:   "Alles bereit.",
  onboarding_morning_habits: "Morning-Habits",
  onboarding_night_habits:   "Night-Habits",
  onboarding_start:         "Jetzt starten 🚀",
  onboarding_next:          "Weiter →",
  onboarding_back:          "←",
  onboarding_skip:          "Überspringen",

  // ── ROUTINE SELECTOR ─────────────────────
  routine_choose:   "Protokoll wählen",
  routine_active:   "AKTIV",
  routine_morning:  "☀️",
  routine_night:    "🌙",

  // ── ERRORS & STATES ──────────────────────
  loading:          "Wird geladen…",
  loading_routines: "Deine Routinen werden geladen…",

  // ── PWA INSTALL ──────────────────────────
  pwa_install_title:    "Habit OS installieren",
  pwa_install_subtitle: "Direkt vom Homescreen öffnen",
  pwa_later:            "Später",
  pwa_install:          "Installieren",
  pwa_guide_title:      "App installieren",
  pwa_guide_subtitle:   "Zum Homescreen hinzufügen",
  pwa_step1: "Tippe auf das Teilen-Symbol unten in Safari",
  pwa_step2: "\"Zum Home-Bildschirm\" auswählen",
  pwa_step3: "\"Hinzufügen\" tippen — fertig!",
  pwa_guide_btn: "Anleitung",
};
